class productGridItem extends HTMLElement {
    constructor() {
        super();
        this.mainCollection = document.querySelector('[js-main-collection]')
        this.desktopPosition = parseInt(this.dataset.destopPosition);
        this.mobilePosition = parseInt(this.dataset.mobilePosition);
        this.currentPage = parseInt(new URLSearchParams(window.location.search).get('page') || 1);
        console.log(this.currentPage, "this.currentPage");

        this.init();
        try {
            if(typeof iWish!=='undefined'){
            setTimeout(function(){
                iWish.checkIwishColl();
            },1500)
            }
        } catch (error) {
            // console.log(error);
        }
    }
    init() {
        if (!window.location.search.includes('page=') || this.currentPage === 1) {
            this.gridItem();
        }
    }
    gridItem() {
        const ProductGridItem = this.mainCollection.querySelector(`[js-product-grid] .product-item:nth-child(${document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition})`);
        if (ProductGridItem) {
            ProductGridItem.insertAdjacentHTML("beforebegin", this.innerHTML)
        }
    }
}
customElements.define('product-grid-item', productGridItem);